import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import Backend from 'i18next-http-backend';
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const siteRegex = /^[A-Z]{2}\/[a-z]{2}$/g;

const parseUrlLanguage = () => {
  let path = window.location.pathname;
  let context = path.substring(1, 6);
  let site = null;
  let language = null;
  if (siteRegex.test(context)) {
    site = context.substring(0, 2);
    language = context.substring(3);
  } else {
    context = null;
  }
  return language+"-"+site;
};



i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init(
    {
      backend: {
        loadPath: '/translation/{{lng}}'
      },
      lng: parseUrlLanguage(),
      fallbackLng: 'en',
      debug: true,

      interpolation: {
        escapeValue: false // not needed for react as it escapes by default
      }
    }
  );


export default i18n;